import React from 'react'

import * as RequerimientoService from 'services/requerimiento.service'
import * as EstadosRequerimientoConstant from 'constants/estadosRequerimiento'

const formatFecha = fecha => {
  if (!fecha) return ''
  const d = new Date(fecha)
  return d.toLocaleDateString('es-PE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

const getColorEstado = estado => {
  const dictEntry = EstadosRequerimientoConstant.__dictionary[estado]
  if (dictEntry && dictEntry.color) return dictEntry.color
  return 'secondary'
}

const CotizacionesResumen = ({ cotizaciones }) => {
  const [pdfUrl, setPdfUrl] = React.useState('')
  const [showPdf, setShowPdf] = React.useState(false)

  if (!cotizaciones || cotizaciones.length === 0) return null

  const handleVerPdf = idCotizacion => {
    RequerimientoService.descargarCotizacion(idCotizacion)
      .then(({ data }) => {
        const url = URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
        setPdfUrl(url)
        setShowPdf(true)
      })
      .catch(() => {})
  }

  const handleClosePdf = () => {
    setShowPdf(false)
    if (pdfUrl) {
      URL.revokeObjectURL(pdfUrl)
      setPdfUrl('')
    }
  }

  return (
    <div className='mt-2 p-2 border rounded'>
      <strong className='small'>Cotizaciones adjuntas:</strong>
      <table className='table table-sm table-bordered mt-1 mb-0' style={{ fontSize: '0.8rem' }}>
        <thead>
          <tr>
            <th>Archivo</th>
            <th>Comentario</th>
            <th>Estado</th>
            <th style={{ width: 50 }}>PDF</th>
          </tr>
        </thead>
        <tbody>
          {cotizaciones.map(cot => (
            <tr key={cot._id} style={cot.flagSeleccionada ? { backgroundColor: '#FFF2CC' } : undefined}>
              <td>{cot.nombreArchivo}</td>
              <td>{cot.comentarioLogistica || '--'}</td>
              <td>
                {cot.flagSeleccionada ? (
                  <span className='badge badge-warning'>FAVORITA</span>
                ) : (
                  <span className='badge badge-secondary'>--</span>
                )}
              </td>
              <td>
                <button
                  className='btn btn-sm btn-outline-primary'
                  title='Ver PDF'
                  onClick={() => handleVerPdf(cot._id)}
                >
                  <i className='fa fa-file-pdf' />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {showPdf && (
        <div className='mt-2'>
          <div className='d-flex justify-content-between align-items-center mb-1'>
            <strong className='small'>Previsualización</strong>
            <button className='btn btn-sm btn-outline-secondary' onClick={handleClosePdf}>
              Cerrar
            </button>
          </div>
          <iframe src={pdfUrl} style={{ width: '100%', height: 400, border: '1px solid #dee2e6' }} title='PDF' />
        </div>
      )}
    </div>
  )
}

const TrazabilidadTimeline = ({ idRequerimiento }) => {
  const [eventos, setEventos] = React.useState([])
  const [cotizaciones, setCotizaciones] = React.useState([])
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    if (!idRequerimiento) return
    setLoading(true)
    Promise.all([
      RequerimientoService.obtenerTrazabilidadxId(idRequerimiento),
      RequerimientoService.obtenerCotizacionesxId(idRequerimiento)
    ])
      .then(([resTraz, resCot]) => {
        setEventos(resTraz.data)
        setCotizaciones(resCot.data)
      })
      .catch(() => {
        setEventos([])
        setCotizaciones([])
      })
      .finally(() => setLoading(false))
  }, [idRequerimiento])

  if (loading) {
    return <div className='text-center py-3'>Cargando trazabilidad...</div>
  }

  if (eventos.length === 0) {
    return <div className='text-center py-3 text-muted'>Sin eventos de trazabilidad.</div>
  }

  const eventosOrdenados = [...eventos].reverse()

  return (
    <div className='timeline-container' style={{ maxHeight: 450, overflowY: 'auto', paddingRight: 8 }}>
      {eventosOrdenados.map((evento, index) => {
        const color = getColorEstado(evento.estadoNuevo)
        const estadoInfo = EstadosRequerimientoConstant.__dictionary[evento.estadoNuevo]
        const nombreEstado = estadoInfo ? estadoInfo.nombre : evento.estadoNuevo

        // Mostrar cotizaciones en el evento de elevacion a gerencia
        const esElevacion = evento.estadoNuevo === EstadosRequerimientoConstant.ELEVADO_A_GERENCIA

        return (
          <div key={evento._id || index} className='d-flex mb-3'>
            <div className='mr-3 text-center' style={{ minWidth: 40 }}>
              <span
                className={`badge badge-${color}`}
                style={{ width: 12, height: 12, borderRadius: '50%', display: 'inline-block' }}
              />
              {index < eventosOrdenados.length - 1 && (
                <div
                  style={{ width: 2, height: '100%', minHeight: 20, backgroundColor: '#dee2e6', margin: '0 auto' }}
                />
              )}
            </div>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start'>
                <div>
                  <strong>{evento.accion}</strong>
                  <span className={`ml-2 badge badge-${color}`}>{nombreEstado}</span>
                </div>
                <small className='text-muted'>{formatFecha(evento.fechaEvento)}</small>
              </div>
              <div className='text-muted small'>
                {evento.nombreUsuario && <span>Por: {evento.nombreUsuario}</span>}
                {evento.rolUsuario && <span className='ml-2'>({evento.rolUsuario})</span>}
              </div>
              {evento.comentario && (
                <div className='mt-1 p-2 bg-light rounded small'>
                  <em>{evento.comentario}</em>
                </div>
              )}
              {evento.adjuntoNombre && (
                <div className='mt-1 small'>
                  <i className='fa fa-paperclip mr-1' />
                  <span className='text-muted'>Adjunto: {evento.adjuntoNombre}</span>
                </div>
              )}
              {esElevacion && <CotizacionesResumen cotizaciones={cotizaciones} />}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default React.memo(TrazabilidadTimeline)
